<template>
  <div class="flex justify-content-center flex-column h-22rem w-full">
    <div class="flex justify-content-center">
      <CustomImage :src="emptyStateImage" class="w-8rem" />
    </div>
    <h3 class="font-semibold text-lg line-height-2 mt-4 text-center">
      {{ emptyStateTitle }}
    </h3>
    <p class="line-height-2 my-1 text-center">
      {{ emptyStateSubtitle }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import recsEmpty from '@centric-os/components/src/assets/recs-empty.png';
import recsBroken from '@centric-os/components/src/assets/empty-state.svg';
import { useTranslation } from '@centric-os/helpers';
import { Image as CustomImage } from '../../../../../../../../../../components/src/core/media';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useRecommendationsStore } from '../../../../../stores/use-recommendations-store';
import { storeToRefs } from 'pinia';

const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_OVERVIEW;

const recommendationsStore = useRecommendationsStore();
const { hasError } = storeToRefs(recommendationsStore);

const emptyStateImage = computed<string>(() => (hasError.value ? recsBroken : recsEmpty));

const emptyStateTitle = computed<string>(() =>
  hasError.value
    ? translate(`${LOCALE_PREFIX}.recommendations.errorStateTitle`)
    : translate(`${LOCALE_PREFIX}.recommendations.emptyStateTitle`),
);

const emptyStateSubtitle = computed<string>(() =>
  hasError.value
    ? translate(`${LOCALE_PREFIX}.recommendations.errorStateSubtitle`)
    : translate(`${LOCALE_PREFIX}.recommendations.emptyStateSubtitle`),
);
</script>
